@import 'theme/theme';

.container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.img {
    object-fit: contain;
}

.fadeIn {
    @keyframes appear {
        from {
            opacity: 0;
        }
    }
    animation: appear 1s;
}
